import { mapDropDown } from '@ninja/utilities';
import { useAppPlatformContextOptions } from '../../../../../../contexts/app';
import { useInsuranceCompanies } from '../../../../../app-init-data';
import { QuotePlanSchema } from '../../../server/map-quotes';
import { QuoteFilters } from '../useQuoteFilterSchema';

type InsuranceCompany = {
	id: number;
	name: string;
	logoUrl: string;
};

export const useInsuranceCompaniesField = (originalQuotes: QuotePlanSchema[]) => {
	const { insuranceCompanies } = useInsuranceCompanies();
	const { translate } = useAppPlatformContextOptions();

	const qualifiedInsuranceCompanies = () => {
		const availableInsuranceCompanies = [...new Set(originalQuotes?.map((q) => q.insuranceCompanyId))];

		return availableInsuranceCompanies
			.map((ic) => {
				const icData = insuranceCompanies.find((i) => i.id === ic);

				return icData;
			})
			.filter((a) => !!a) as InsuranceCompany[];
	};

	const getInsuranceCompaniesField = mapDropDown<QuoteFilters, InsuranceCompany, 'id'>({
		field: 'insurerCompanyId',
		isEditable: true,
		label: translate('quote-list:filters.insurer-company'),
		placeholder: translate('quote-list:select'),
		isHidden: false,
		valueKey: 'id',
		labelKey: 'name',
		options: qualifiedInsuranceCompanies(),
	});

	return { getInsuranceCompaniesField };
};
